import { useLingui } from '@lingui/react/macro';
import { DatePicker } from '@repo/videa-components';
import { useAtom, useSetAtom } from 'jotai';

import { useGetDateFNSLocale } from '@/locales/helpers';

import {
  operatoryFilterAtom,
  selectDateAtom,
  selectedProvidersAtom,
} from '../../../../modules/patientList/atoms';
import { PatientListPageLayoutContextMap } from '../../../../modules/patientList/types';
import { PatientSearch } from '../PatientSearch';

export const AutoVerifyTopbarContent = () => {
  const { t } = useLingui();
  const dateLocale = useGetDateFNSLocale();

  const [date, setDate] = useAtom(selectDateAtom);
  const setSelectedOperatories = useSetAtom(operatoryFilterAtom);
  const setSelectedProviders = useSetAtom(selectedProvidersAtom);

  const handleSelectDate = (newDate: Date) => {
    setDate(newDate);
    setSelectedOperatories([]);
    setSelectedProviders([]);
  };

  return (
    <div className="vai-flex vai-items-center vai-gap-4">
      {/* Date Picker with Navigation */}
      <DatePicker
        date={date || undefined}
        setDate={handleSelectDate}
        placeholderText={t`Pick a date`}
        locale={dateLocale}
        showPreviousNextButtons
        showTodayButton
        todayButtonText={t`Back to Today`}
      />

      {/* Search Bar */}
      <div className="vai-w-80">
        <PatientSearch context={PatientListPageLayoutContextMap.AutoVerify} />
      </div>
    </div>
  );
};
